import { render, staticRenderFns } from "./SidebarAddNewProspect.vue?vue&type=template&id=c5b82020&"
import script from "./SidebarAddNewProspect.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewProspect.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewProspect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports